<template>
<!-- 试卷配置管理 列表页 -->
    <div>
        <el-form :inline="true" :model="form" ref="form" class="paperForm">
            <el-form-item>
                <el-select v-model="form.examPlanId" filterable clearable :placeholder="searchFormTextConfig.examPlan">
                    <el-option v-for="(item,index) in examPlanOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.subjectId" filterable clearable :placeholder="searchFormTextConfig.subjectId">
                    <el-option v-for="(item,index) in subjectOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.examCategory" filterable clearable :placeholder="searchFormTextConfig.examCategory">
                    <el-option v-for="(item,index) in examCategoryOptions" :key="index" :label="item.dict_label" :value="item.dict_value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.examPaperId" filterable clearable :placeholder="searchFormTextConfig.examPaperId">
                    <el-option v-for="(item,index) in paperNameOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.examStatus" clearable :placeholder="searchFormTextConfig.examStatus">
                    <el-option v-for="(item,index) in examOptions" :key="index" :label="item.dict_label" :value="item.dict_value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="search(1)">{{ searchFormTextConfig.button.search }}</el-button>
                <el-button @click="reset">{{ searchFormTextConfig.button.reset }}</el-button>
            </el-form-item>
        </el-form>
        <!--<p class="info">
            <span>已选：<i>{{selectRow.length}}</i>/{{tableData.length||0}} </span>
            <el-button :disabled="!selectRow.length" @click="row=selectRow,setDialogVisible=true" type="primary" size="mini" style="margin-left:10px">
                {{ tableTextConfig.button.setPaper.name }}</el-button>
        </p>-->
        <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange" stripe size="medium" :height="height" style="width:100%">
                <el-table-column type="selection" width="48" fixed="left" align="center"></el-table-column>
                <el-table-column prop="examPlan.name" :label="tableTextConfig.examPlan" :min-width="flexColumnWidth('examPlan',4,tableData)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subject" :label="tableTextConfig.subject" :min-width="flexColumnWidth('subject',4,tableData)" show-overflow-tooltip></el-table-column>
                <el-table-column :label="tableTextConfig.examCategory" width="100px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ examCategoryFormatter(scope.row.examCategory) }}
                    </template>
                </el-table-column>
                <el-table-column prop="startTime" :label="tableTextConfig.examTime" min-width="140px" show-overflow-tooltip :formatter="examTimeFormatter"></el-table-column>
                <el-table-column :label="tableTextConfig.examDuration" width="100px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.examDuration }} {{examDurationFormatter(scope.row.examDurationUnit)}}
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.examPaperName" :min-width="flexColumnWidth('examPaperName',4,tableData)" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div>
                                    <span v-for="paper in scope.row.examPaperList" style="white-space:nowrap; overflow: hidden; text-overflow: ellipsis; display: block; width: 100%">
                                        {{ paper.examPaperName }}
                                    </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="examineeCount" width="100px" :label="tableTextConfig.examineeCount"></el-table-column>
                <el-table-column prop="examStatus" width="120px" :label="tableTextConfig.examStatus">
                    <template slot="header" slot-scope="scope">
                        {{tableTextConfig.examStatus}}<el-tooltip class="item" effect="dark"
                                        content="1.  无法开赛：配置未完成，需管理员完善设置。2.  未开赛：配置完成，未到开始时间，请耐心等待。3.  已开赛：配置完成，当前在竞赛时段内，选手可开始作答。4.  竞赛结束：超过竞赛结束时间，可进行成绩评阅和统计。">
                            <el-button icon="el-icon-question" type="text" style="color: #999"></el-button>
                    </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-tag v-for="item in examOptions" v-if="item.dict_value == scope.row.examStatus" :type="scope.row.examStatus==0?'danger':scope.row.examStatus==1?'warning':scope.row.examStatus==2?'success':''">{{ item.dict_label }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="update" :label="tableTextConfig.update" min-width="140px">
                    <template slot-scope="scope">
                        <p>{{scope.row.updatedByUsername}}</p>
                        <p class="updateDate">{{scope.row.updatedAt | formatTime}}</p>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="150px">
                    <template slot-scope="scope">
                        <el-button plain type="primary" size="mini" @click="$router.push({name:'editExam', query: { id: scope.row.id}})">
                            {{ tableTextConfig.button.edit }}</el-button>
                        <el-button plain type="danger" size="mini" @click="openDeleteDialog(scope.row)"  v-hasPermi="['arrangement:exam:delete']">
                            {{ tableTextConfig.button.delete.name }}</el-button>
                    </template>
                </el-table-column>
        </el-table>
        <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
        <!--<set-paper :show.sync="setDialogVisible" :row="row" :timeOptions="timeOptions" @close="close"></set-paper>-->
        <delete-exam-dialog ref="deleteDialog" @success="search(1)"></delete-exam-dialog>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
/*import setPaper from '../../dialog/setPaper.vue'*/
import deleteExamDialog from '../../dialog/deleteExamDialog.vue'
import {getDict} from "@/api/dict"

export default {
    components: {
        pagination, deleteExamDialog
    },
    props: ['examPlanOptions','subjectOptions','examPaperStatusOptions'],
    data() {
        return {
            height: 250,
            loading: true,
            form: {
                examPlanId: '',
                subjectId: '',
                examPaperId: '',
                examPaperStatus: '',
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            paperNameOptions: [],
            tableData: [],
            selectRow: [],
            row: [],
            setDialogVisible: false,
            timeOptions: [],
            examCategoryOptions: [],
            unitOptions: [],
            examOptions: [],
            examName: null
        }
    },
    computed: {
        searchFormTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.paperConfig.searchForm
        },
        tableTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.paperConfig.table
        }
    },
    watch: {
        tableData () {
            if (this.tableData.length == 0) {
                this.height = 120
            }else {
                this.updateHeight()
            }
        }
    },
    created() {
        this.$store.dispatch("getDict",'exam_duration').then(res => {
            this.timeOptions = res.data
        });
        getDict('exam_category').then(res => {
            this.examCategoryOptions = res.data
        })

        this.$store.dispatch("getDict", 'exam_duration_unit').then(res => {
            this.unitOptions = res.data
        });
        this.$store.dispatch("getDict", 'exam').then(res => {
            this.examOptions = res.data
        });
        this.getPaperList()
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    methods: {
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.$store.dispatch("getExamPaperList", this.form).then(res => {
                if (res) {
                    this.loading = false
                    this.tableData = res.data.list
                    this.total = res.data.total
                    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                }
            });
            this.$nextTick(()=>{
                this.$refs.multipleTable.doLayout()
            })
        },
        getPaperList() {
            this.$store.dispatch("getArrangementExamPaper").then(res => {
                this.paperNameOptions = res.data
            });
        },
        handleSelectionChange(val) {
            this.selectRow = []
            for (let i = 0; i < val.length; i++) {
                const e = val[i];
                this.selectRow.push(e)
            }
        },
        reset() {
            this.form = this.$options.data().form
            this.form.pageSize = 20
            this.search(1)
        },
        close() {
            this.setDialogVisible = false
            this.row = []
        },
        updateHeight() {
            if (document.getElementsByClassName('paperForm')[0]) {
                this.height = document.body.clientHeight - document.getElementsByClassName('paperForm')[0].clientHeight - 290
                this.height = this.height < 420 ? 420 : this.height
            }
        },
        examPaperStatusFormatter(val) {
            let already = this.examPaperStatusOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        examCategoryFormatter(val) {
            let already = this.examCategoryOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        examDurationFormatter(val) {
            let already = this.unitOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        examTimeFormatter(row) {
            if (row.startTime && row.endTime) {
                return row.startTime + ' ~ ' + row.endTime
            } else {
                return ''
            }
        },
        openDeleteDialog(row) {
            this.$refs.deleteDialog.open(row.id, row.examPlan.name)
        },
        delet(row) {
            let deleteTextConfig = this.tableTextConfig.button.delete
            this.$confirm(deleteTextConfig.message, deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteArrangeExam",row.id+'').then(res => {
                    this.$message({
                        type: 'success',
                        message: deleteTextConfig.success
                    });
                    this.search(1)
                });
            }).catch(() => {});
        },
    }
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}
.info span {
    color: #C0C4CC;
    margin-left: 12px;
}
.info i {
    color: #555;
}
.flex {
    display: flex;
}
.flex span:first-child {
    width: 76px;
}
.flex span:last-child {
    width: calc(100% - 76px);
}
</style>